module.exports = __webpack_public_path__ + "img/getup_des_1.6867b312.jpg";